import { Grid, IconButton } from "@mui/material";
import { ReactComponent as AddCircle } from "assets/add-circle.svg";
import DeleteCircle from "assets/DeleteCircle";
import Input from "components/common/Input";
import Typography from "components/common/Typography";
import { useFieldArray, useFormContext } from "react-hook-form";
import { tokens } from "styles/Tokens";
import { urlRegex } from "utils/CommonConstants";

interface Props {
  label?: string;
}

type FormValues = {
  firstName: string;
  linkToResources: {
    title: string;
    url: string;
  }[];
};

export default function Resources(props: Props) {
  const {
    register,
    control,
    watch,
    formState: { errors }
  } = useFormContext<FormValues>();
  const { fields, append, remove } = useFieldArray({
    name: "linkToResources",
    control
  });

  return (
    <>
      {props.label && (
        <Typography variant={"body2"} component="span" textAlign="left">
          {props.label}
        </Typography>
      )}
      {fields.map((field, index) => {
        return (
          <div key={field.id}>
            <Grid container key={field.id} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Grid item md={5}>
                <Input
                  register={register}
                  validations={{
                    required: !!watch(`linkToResources.${index}.url`)
                  }}
                  name={`linkToResources.${index}.title`}
                  placeholder="Insert Resource Title"
                  value={field.title}
                  error={errors?.linkToResources?.[index]?.title}
                />
              </Grid>

              <Grid item md={5}>
                <Input
                  register={register}
                  validations={{
                    required: !!watch(`linkToResources.${index}.title`),
                    validate: (value: string) => (value ? urlRegex.test(value) || "Invalid URL" : true)
                  }}
                  name={`linkToResources.${index}.url`}
                  placeholder="Insert Resource URL"
                  value={field.url}
                  error={errors?.linkToResources?.[index]?.url}
                  inputProps={{
                    color: tokens.Text.General.Color,
                    fontWeight: 700,
                    borderColor: tokens.Border.General.Primary
                  }}
                />
              </Grid>

              <Grid
                item
                md={1}
                sx={{
                  display: "flex",
                  border: `1px solid ${tokens.Border.General.Tertiary}`,
                  borderRadius: "8px",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                  height: "40px"
                }}
              >
                {fields.length - 1 === index ? (
                  <IconButton
                    onClick={() =>
                      append({
                        title: "",
                        url: ""
                      })
                    }
                  >
                    <AddCircle />
                  </IconButton>
                ) : (
                  <IconButton onClick={() => remove(index)}>
                    <DeleteCircle color={tokens.Icon.General.Primary} />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </div>
        );
      })}
    </>
  );
}
